import React, { useState } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Reusable Q&A accordion — same interaction as the homepage FAQ.
// items: [{ q, a }]
const Accordion = ({ items, defaultOpen = -1 }) => {

    const [openIndex, setOpenIndex] = useState(defaultOpen);

    return (
        <div>
            {items.map((item, index) => {
                const open = openIndex === index;
                return (
                    <div key={index} style={{
                        borderBottom: `1px solid ${Appearance.colors.border()}`,
                        borderTop: index === 0 ? `1px solid ${Appearance.colors.border()}` : 'none',
                    }}>
                        <div
                            onClick={() => setOpenIndex(open ? -1 : index)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 20,
                                padding: Utils.isMobile() ? '20px 4px' : '22px 8px',
                                cursor: 'pointer',
                            }}>
                            <span style={{
                                fontFamily: Appearance.fonts.body,
                                fontWeight: 600,
                                fontSize: Utils.isMobile() ? 15 : 17,
                                lineHeight: 1.35,
                                color: open ? Appearance.colors.primary() : Appearance.colors.text(),
                                transition: 'color 0.2s ease',
                            }}>
                                {item.q}
                            </span>
                            <div style={{
                                width: 28,
                                height: 28,
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.25s ease',
                            }}>
                                <i className={'fas fa-chevron-down'} style={{ fontSize: 14, color: open ? Appearance.colors.primary() : Appearance.colors.lightGrey }} />
                            </div>
                        </div>
                        <div style={{
                            maxHeight: open ? 640 : 0,
                            opacity: open ? 1 : 0,
                            overflow: 'hidden',
                            transition: 'max-height 0.3s ease, opacity 0.3s ease',
                        }}>
                            <p style={{
                                ...Appearance.textStyles.body(),
                                margin: 0,
                                padding: Utils.isMobile() ? '0 4px 22px 4px' : '0 60px 26px 8px',
                            }}>
                                {item.a}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Accordion;
